import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Typography,
  Dialog,
  DialogContent,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ImageList,
  ImageListItem,
  Divider,
  CardMedia,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import ReportViewer from '../../../components/ReportsBuilder/ReportViewer';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../../themes/reportTheme';
import { ExpandMore } from '@mui/icons-material'; // Import ExpandMore icon
// import Signature from '../VisitDetails'; // Adjust the path if necessary
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import moment from 'moment';

// VisitReports.js - Using Grouped Questions to Render Report
const VisitReports = ({
  questionsUpdated,
  fetchTemplateAndInputs,
  id,
  reportTemplate,
  reportInputs,
  showReportViewer,
  closeReportViewer,
  downloadReport,
}) => {
  const {
    visitsReportSDateStr,
    visitsReportSLocStr,
    visitsReportQuestionStr,
    visitsReportAnswerStr,
    visitsReportTitleStr,
  } = useTranslationHook();

  const Signature = ({ signatures }) => {
    return (
      <Box mb={2} width='100%'>
        <Card>
          <CardContent>
            <Box display='flex' flexDirection='row' flexWrap='wrap'>
              {signatures.map((signature, index) => (
                <Box key={index} mb={2} width='50%'>
                  <Typography variant='h6'>{signature.questionText}</Typography>
                  <CardMedia
                    component='img'
                    image={signature.answer}
                    alt='Firma'
                  />
                  <Typography variant='body1'>
                    {visitsReportSDateStr}{' '}
                    {moment(signature.meta_date).format('DD/MM/YYYY, h:mm a')}
                  </Typography>
                  <Typography variant='body1'>
                    {visitsReportSLocStr} {signature.meta_loc}
                  </Typography>
                </Box>
              ))}
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  };

  const ReportQuestion = ({ questions }) => {
    const firstQuestion = questions[0];

    if (firstQuestion.type === null) {
      //#region Signatures
      return <Signature signatures={questions} />;
      //#endregion
    } else if (firstQuestion.type === 15) {
      //#region Images
      return (
        <Box mb={2}>
          <Card>
            <CardContent>
              <Typography variant='h6'>
                {visitsReportQuestionStr} {firstQuestion.question_number}:{' '}
                {firstQuestion.questionText}
              </Typography>
              <ImageList cols={questions.length}>
                {questions.map((question, index) => (
                  <ImageListItem key={index}>
                    <img
                      src={question.answer}
                      alt={`Imagen de respuesta ${index + 1}`}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </CardContent>
          </Card>
        </Box>
      );
      //#endregion
    } else if (firstQuestion.type === 10) {
      //#region Sections
      return (
        <Box mb={2}>
          <Card>
            <CardContent>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{
                    marginLeft: '-1rem',
                  }}
                >
                  <Typography variant='h6'>
                    {visitsReportQuestionStr} {firstQuestion.question_number}:{' '}
                    {firstQuestion.questionText}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box mb={2}>
                    {firstQuestion.answers.map((subQuestion, index) => (
                      <ReportQuestion key={index} questions={[subQuestion]} />
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </CardContent>
          </Card>
        </Box>
      );
      //#endregion
    } else {
      //#region General
      return (
        <Box mb={2}>
          <Card>
            <CardContent>
              <Typography variant='h6'>
                {visitsReportQuestionStr} {firstQuestion.question_number}:{' '}
                {firstQuestion.questionText}
              </Typography>
              {questions.map((question, index) => (
                <Typography key={index} variant='body1'>
                  {visitsReportAnswerStr}: {question.answer}
                </Typography>
              ))}
            </CardContent>
          </Card>
        </Box>
      );
      //#endregion
    }
  };

  //To check the pdfme values
  // console.log('reportTemplate', reportTemplate)
  // console.log('reportInputs', reportInputs)
  // // console.log('showReportViewer', showReportViewer)
  // console.log('closeReportViewer', closeReportViewer)
  // console.log('downloadReport', downloadReport)

  //Change this to true to see the new report format
  const newReportFormat = true;

  return (
    <Box flex={6} mx={2}>
      {!newReportFormat ? (
        <>
          <Typography fontWeight='bold'>{visitsReportTitleStr}</Typography>
          <Box className='visitReportsContainer'>
            {Object.values(questionsUpdated).map((questions) => (
              <ThemeProvider theme={theme} key={questions[0].question_number}>
                <ReportQuestion questions={questions} />
              </ThemeProvider>
            ))}
          </Box>
          {/* <Dialog
            open={showReportViewer}
            onClose={closeReportViewer}
            maxWidth='md'
          >
            <DialogContent sx={{ width: '100%', height: '70%' }}>
              <ReportViewer
                template={reportTemplate}
                inputs={reportInputs}
                onClose={closeReportViewer}
                downloadReport={() => downloadReport(id)}
              />
            </DialogContent>
          </Dialog> */}
        </>
      ) : (
        <>
          <Box
            flex={6}
            sx={{ overflowY: 'scroll !important' }}
            width={'100%'}
            height={'100%'}
          >
            <Box
              className='visitReportsContainer'
              sx={{ width: '100%', overflowY: 'scroll !important' }}
            >
              <ReportViewer
                template={reportTemplate}
                inputs={reportInputs}
                onClose={closeReportViewer}
                downloadReport={() => downloadReport(id)}
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default VisitReports;
